import { render } from "./ProfileNav.vue?vue&type=template&id=8cef7df8"
import script from "./ProfileNav.vue?vue&type=script&lang=js"
export * from "./ProfileNav.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__